import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './AboutCoreValuesSection.scss';

const AboutCoreValuesSection = () => {
    const { t } = useTranslation();

    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const coreValues = [
        { id: 1, title: t('value_1'), description: t('value_1_desc') },
        { id: 2, title: t('value_2'), description: t('value_2_desc') },
        { id: 3, title: t('value_3'), description: t('value_3_desc') },
        { id: 4, title: t('value_4'), description: t('value_4_desc') },
        { id: 5, title: t('value_5'), description: t('value_5_desc') }
    ];

    return (
        <section className="about-core-values">
            <div className="about-core-values__container">
                <motion.h2 className="about-core-values__title" {...fadeUp(0, 1.1)}>{t('our_core_values')}</motion.h2>
                <motion.p className="about-core-values__subtitle" {...fadeUp(0.15)}>{t('core_values_description')}</motion.p>

                <div className="about-core-values__list">
                    {coreValues.map((value, index) => (
                        <motion.div key={value.id} className="about-core-values__item" {...fadeUp(0.3 + index * 0.12)}>
                            <span className="about-core-values__number">
                                {String(value.id).padStart(2, '0')}
                            </span>
                            <div className="about-core-values__content">
                                <h3 className="about-core-values__heading">{value.title}</h3>
                                <p className="about-core-values__text">{value.description}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutCoreValuesSection;
